import { useEffect, useState } from "react";
import axios, { Canceler } from "axios";
import getSummary from "./getSummary";
import { Summary } from "../../containers/NewOrderContainer/types";
import useResetTimeout from "../useResetTimeout";
import deferCall from "../../utils/deferCall";

let cancel: Canceler;

let lastTimerId: any = 0;

const useSummary = (
  currencyId: string | undefined,
  currencyAmount: number,
  isFcaCurrency: string,
  companyId?: string,
  isReturn?: boolean
) => {
  const resetTimeout = useResetTimeout();
  const [summary, setSummary] = useState<Summary>();

  useEffect(() => {
    lastTimerId = deferCall(
      async () => {
        try {
          await getSummary(
            axios,
            cancel,
            c => (cancel = c),
            currencyId,
            currencyAmount,
            companyId || "",
            isReturn || false,
            isFcaCurrency || "0",
            setSummary
          );
          resetTimeout();
        } catch (err) {
          if (err.message === "Network Error") {
            document.location.href = "/";
          }
        }
      },
      lastTimerId,
      200
    );
  }, [currencyId, currencyAmount, companyId, isReturn, isFcaCurrency]);

  return { summary };
};

export default useSummary;
